const AVAILABLE_LOCALES = {
  'en-EN': {
    labelTranslation: 'locales.en'
  },
  'pt-PT': {
    labelTranslation: 'locales.pt'
  }
};

export default AVAILABLE_LOCALES;
